var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.467 3.45681C13.9075 3.45681 11.8325 5.53176 11.8325 8.09134C11.8325 10.6509 13.9075 12.7259 16.467 12.7259C19.0266 12.7259 21.1016 10.6509 21.1016 8.09134C21.1016 5.53176 19.0266 3.45681 16.467 3.45681ZM9.93409 8.09134C9.93409 4.48329 12.859 1.55838 16.467 1.55838C20.0751 1.55838 23 4.48329 23 8.09134C23 11.6994 20.0751 14.6243 16.467 14.6243C12.859 14.6243 9.93409 11.6994 9.93409 8.09134Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64969 15.7411C7.32364 15.7411 6.24866 16.8161 6.24866 18.1422C6.24866 19.4682 7.32364 20.5432 8.64969 20.5432C9.97574 20.5432 11.0507 19.4682 11.0507 18.1422C11.0507 16.8161 9.97574 15.7411 8.64969 15.7411ZM4.35023 18.1422C4.35023 15.7676 6.27516 13.8427 8.64969 13.8427C11.0242 13.8427 12.9491 15.7676 12.9491 18.1422C12.9491 20.5167 11.0242 22.4416 8.64969 22.4416C6.27516 22.4416 4.35023 20.5167 4.35023 18.1422Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.18271 7.92386C3.47342 7.92386 2.89843 8.49885 2.89843 9.20814C2.89843 9.91742 3.47342 10.4924 4.18271 10.4924C4.892 10.4924 5.46699 9.91742 5.46699 9.20814C5.46699 8.49885 4.892 7.92386 4.18271 7.92386ZM1 9.20814C1 7.45037 2.42495 6.02542 4.18271 6.02542C5.94048 6.02542 7.36542 7.45037 7.36542 9.20814C7.36542 10.9659 5.94048 12.3908 4.18271 12.3908C2.42495 12.3908 1 10.9659 1 9.20814Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/bubble.5e385272374a6dc89ce060b6be09ca19.svg";
export { ForwardRef as ReactComponent };